import { render, staticRenderFns } from "./baozhuanghetong.vue?vue&type=template&id=07b9e4c7&scoped=true&"
import script from "./baozhuanghetong.vue?vue&type=script&lang=js&"
export * from "./baozhuanghetong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b9e4c7",
  null
  
)

export default component.exports